import React, { createContext, useContext } from 'react';
import { CurrentUser } from '../types';

const CurrentUserContext = createContext<CurrentUser | undefined>(undefined);

type CurrentUserProviderProps = {
  user: CurrentUser;
  children: React.ReactNode;
};
export const CurrentUserProvider = ({
  user,
  children,
}: CurrentUserProviderProps) => {
  return (
    <CurrentUserContext.Provider value={user}>
      {children}
    </CurrentUserContext.Provider>
  );
};

export const useCurrentUser = (): CurrentUser => {
  const context = useContext(CurrentUserContext);

  if (!context) {
    throw new Error('useCurrentUser must be used within a CurrentUserProvider');
  }

  return context;
};
